export default "__VITE_ASSET__Bt7Ad3mR__"